import { render, staticRenderFns } from "./outbill.vue?vue&type=template&id=64ab2cd4"
import script from "./outbill.vue?vue&type=script&lang=js"
export * from "./outbill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports